import React from "react";
import { TablePage } from "~/components/Table";
import { LqsNavigation } from "~/lqs";
import { TopicFilters } from "./components/TopicFilters";
import {
  TopicSearchRequestProvider,
  TopicTable,
} from "./components/TopicTable";

export function TopicsPage() {
  return (
    <TablePage
      title="Search Topics"
      navigation={<LqsNavigation />}
      RequestProvider={TopicSearchRequestProvider}
      table={<TopicTable />}
      filters={<TopicFilters />}
    />
  );
}
